import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostAdminClients_municipalityIdData_importBatches_idUndo_preview = z.any()
export type TagsPostAdminClients_municipalityIdData_importBatches_idUndo_preview = z.infer<typeof tagsPostAdminClients_municipalityIdData_importBatches_idUndo_preview>

export const paramsPostAdminClients_municipalityIdData_importBatches_idUndo_preview = z.object({ "municipalityId": z.string().uuid(), "id": z.string().uuid() })
export type ParamsPostAdminClients_municipalityIdData_importBatches_idUndo_preview = z.infer<typeof paramsPostAdminClients_municipalityIdData_importBatches_idUndo_preview>

export const bodyPostAdminClients_municipalityIdData_importBatches_idUndo_preview = z.object({ "undoToken": z.string().min(64).max(64).optional() })
export type BodyPostAdminClients_municipalityIdData_importBatches_idUndo_preview = z.infer<typeof bodyPostAdminClients_municipalityIdData_importBatches_idUndo_preview>

export const responsePostAdminClients_municipalityIdData_importBatches_idUndo_preview = z.object({ "payload": z.object({ "batchId": z.string(), "canUndo": z.boolean(), "undone": z.boolean(), "undoToken": z.string(), "blockers": z.array(z.string()), "records": z.number().int() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostAdminClients_municipalityIdData_importBatches_idUndo_preview = z.infer<typeof responsePostAdminClients_municipalityIdData_importBatches_idUndo_preview>

interface IPostAdminClients_municipalityIdData_importBatches_idUndo_preview extends BaseMethodType {
  tags: TagsPostAdminClients_municipalityIdData_importBatches_idUndo_preview,
  params: ParamsPostAdminClients_municipalityIdData_importBatches_idUndo_preview,
  body: BodyPostAdminClients_municipalityIdData_importBatches_idUndo_preview,
  response: ResponsePostAdminClients_municipalityIdData_importBatches_idUndo_preview
}
export const URL = '/admin/clients/:municipalityId/data-import/batches/:id/undo-preview'
export const validation = {
  post: {
    tags: tagsPostAdminClients_municipalityIdData_importBatches_idUndo_preview,
    params: paramsPostAdminClients_municipalityIdData_importBatches_idUndo_preview,
    body: bodyPostAdminClients_municipalityIdData_importBatches_idUndo_preview,
    response: responsePostAdminClients_municipalityIdData_importBatches_idUndo_preview
  }
}
export interface AdminClients_municipalityIdData_importBatches_idUndo_preview extends BaseRouteType {
  post: IPostAdminClients_municipalityIdData_importBatches_idUndo_preview
}